<template>
    <div id="clientesmain">
        <div class="container-fluid">
            <div class="row" data-aos="fade-down">
                <div class="col-md-6" style="text-align:left; margin-top:100px;">
                    <div class="titles-cont">
                        <h4 v-html="state.title">
                            <hr>
                        </h4>
                        <h1 data-aos="fade-right">{{state.subTitle}}</h1>
                        <br>
                        <p class="pcont" v-html="state.clientTxt"></p>
    
                    </div>
                </div>
                <div class="col-md-6 img-cont">
                    <img src="./../../assets/imgs/clientes_foto1.png" width="90%" alt="">
                </div>
                <div class="col-md-12 client-icon-cont">
                    <div class="clientes-container" style="margin-top:300px;">
                        <img data-aos="zoom-in" src="../../assets/logos/logo_alen_blanco.png">
                        <img data-aos="zoom-in" src="../../assets/logos/logo_cemenquin_blanco.png">
                        <img data-aos="zoom-in" src="../../assets/logos/logo_fevisa_blanco.png">
                        <img data-aos="zoom-in" src="../../assets/logos/logo_jumex_blanco.png"> &nbsp&nbsp
                    </div>
                    <div class="clientes-container">
                        <img data-aos="zoom-in" src="../../assets/logos/logos_azteca_blanco.png">
                        <img data-aos="zoom-in" src="../../assets/logos/logo_maseca_blanco.png">
                        <img data-aos="zoom-in" src="../../assets/logos/logo_pazher_blanco.png">
                        <img data-aos="zoom-in" src="../../assets/logos/logo_psf_blanco.png">
                    </div>
                    <div class="clientes-container" style="    margin-bottom: 0px;">
                        <img data-aos="zoom-in" src="../../assets/logos/logo_sunpower_blanco.png">
                        <img data-aos="zoom-in" src="../../assets/logos/logo_vitro_blanco.png">
                        <img data-aos="zoom-in" src="../../assets/logos/logo_zahori_blanco.png">
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-12 footer-container" style="padding:20px;">
            <router-link to="/contacto" tag="a">
                <h3>{{this.$store.state.activeList.footerPage.title}}</h3>
            </router-link>
            <hr style="border-top:1px solid white;">
            <p>Copy right @2017 - All Rights Reserved</p>
        </div>
    </div>
</template>

<script>
export default {

    methods: {
    },
    components: {
    },
    computed: {
        state(){
            return this.$store.state.activeList.clientsPage
        }
    },
    mounted() {

    }
}
</script>

<style lang="scss" scoped>
@import '~varmix';


.footer-container {
    background-color: $gris;
    color: white;
}

a {
    color: white;
}

.main-content {
    display: block;
    color: $gris;
    height: 100%;
}

.titles-cont {
    padding: 80px;
}

hr {
    display: inline-block;
    vertical-align: middle;
    height: 2px;
    border: 0;
    width: 20%;
    border-top: 2px solid $rojo;
    margin: 1em 1em;
    padding: 0;
}

h1 {
    color: $azul;
    font-size: 80pt;
}

.text-container {
    text-align: left;
    margin-top: 5%;
}


.small-title {
    width: 100%;
    text-align: right;
    vertical-align: middle;
}

.clientes-container {
    margin: 50px;
}

.client-icon-cont {
    margin-top: -100px;
    background-color: $azul;
    z-index: -1;
}

.pcont {
    width: 500px;
    font-size: 15pt;
}

.img-cont {
    text-align: right;
    padding: 0;
}

.clientes-container img {
    margin: 25px;
    width: 200px;
}

@media screen and (max-width:1700px) {
    .client-icon-cont {
        margin-top: -90px;
    }
}

@media screen and (max-width:1300px) {
    .client-icon-cont {
        margin-top: 0px;
    }
    h1 {
        color: $azul;
        font-size: 40pt;
    }

    .titles-cont {
        padding: 10px;
    }
    .clientes-container {
        margin: 0px;
    }
}

@media screen and (max-width:1080px) {
    .img-cont {
        display: none;
    }
    .client-icon-cont {
        margin-top: 10px;
    }
    .pcont {
        width: 100%;
    }
}
</style>



// WEBPACK FOOTER //
// clientes.vue?789a6574